/*
 * @fileOverView Contact Form component definition
 */

import Vue from 'vue';
import Form from 'components/foundation/forms/form/form.mixin';
import Analytics from 'mixins/analytics.mixin';
import axios from 'axios';

/**
 * [Form Vue]
 * @type {class}
 */
Vue.component('contact-form-vue', {
  mixins: [
    Analytics,
    Form
  ],

  data: function() {
    return {
      title: "Contact Us",
      success: false,
      message: "",
      errorMessage: ""
    }
  },

  methods: {
    initAnalytics() {
      this.setFormAnalyticsData({
        "formType": "Contact Us",
        "formName": "contact us"
      });
      this.pushFormViewedEvent();
      this.$nextTick(() => {
        this.attachFormStartedEvent(this.$refs.form, this.pushFormStartedEvent);
      });
    },

    /**
     * Handles form submission. Submits to Contact Us Endpoint.
     *
     * @param {object} form
     *   The form object
     */
    submit(form) {
      if (this.isLoading) return;

      this.isLoading = true;
      let formData = new FormData(this.$refs.form);

      axios({
        method: 'post',
        url: '/contact/request',
        data: formData,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      })
      .then(response => {
        this.success = response.data.isSuccessful;

        if (this.success) {
          this.title = "Thank You";
          this.message = response.data.message;

          this.pushFormSubmissionSucceededEvent();
        }
        else {
          this.errorMessage = response.data.message;

          this.pushFormSubmissionFailedEvent(this.errorMessage);
        }
      })
      .catch(() => {
        // Catch server 500
        this.success = false;
        this.errorMessage = 'Error Submitting your request.';
      })
      .then(() => {
        this.isLoading = false;
      });
    }
  }
});
